import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { ProspectProfileModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

const { action, name } = ProspectProfileModuleConstant;

export default class ProspectProfileStore implements ltFramework.IProspectProfileStore {
	public getInitialData(): ltFramework.IProspectProfile {
		return (Store.state as ltFramework.IStoreState).prospectProfileModule.prospectProfile;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(name + '/' + action.initialize);
	}

	public listen(callback: (state: ltFramework.IProspectProfile) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(name + '/')) {
				callback((state as ltFramework.IStoreState).prospectProfileModule.prospectProfile);
			}
		});
	}

	public updateProspectClub(clubId: number): Promise<void> {
		return Store.dispatch(name + '/' + action.updateProspectClub, clubId);
	}
}
